import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageTeamSettings
{
    constructor(targetElement)
    {
        const userTab = ele.byQuery(".project-list");
        const autoSuggests = userTab.querySelectorAll("[data-autosuggest]");
        web.initializeAutosuggestsFromApi(autoSuggests);

        this.teamId = ele.byId("team-id").value;
        const deleteTab = ele.byId("deleteTeam");
        if (deleteTab)
        {
            deleteTab.addEventListener("activated", () =>
            {
                this.checkDelete(this.teamId);
            });
        }
    }

    checkDelete(teamId)
    {
        const teamLink = ele.byId("team-link").value;
        const deleteTab = ele.byId("deleteTab");
        if (!deleteTab) return;
        const loadingTab = deleteTab.querySelector(".checkDelete");
        ele.show(loadingTab);
        api.get("teams/" + teamId + "/dependencies", (res) =>
        {
            ele.hide(loadingTab);
            let namespaceCount = 0;
            let opsCount = 0;
            if (res.data.namespaces)
            {
                const namespaces = Object.keys(res.data.namespaces);
                namespaceCount = namespaces.length;
                namespaces.forEach((nsName) =>
                {
                    const ops = res.data.namespaces[nsName];
                    opsCount += ops.length;
                });
            }
            let projectsCount = 0;
            if (res.data.projects)
            {
                projectsCount = res.data.projects.length;
            }
            const opdependencies = ele.byId("opdependencies");
            const patchdependencies = ele.byId("patchdependencies");
            if (opdependencies)
            {
                const okInfo = opdependencies.querySelector(".highlightBlock.info");
                const errorInfo = opdependencies.querySelector(".highlightBlock.error");
                if (opsCount > 0)
                {
                    const text = errorInfo.querySelector(".text");
                    text.innerHTML = "Team <a href=\"" + teamLink + "#teamNamespaces\">is responsible</a> for " + namespaceCount + " namespaces with " + opsCount + " ops, clean them up before you delete the team.";
                    ele.hide(okInfo);
                    ele.show(errorInfo);
                }
                else
                {
                    ele.hide(errorInfo);
                    ele.show(okInfo);
                }
                ele.show(opdependencies);
            }

            if (patchdependencies)
            {
                const okInfo = patchdependencies.querySelector(".highlightBlock.info");
                if (projectsCount > 0)
                {
                    const text = okInfo.querySelector(".text");
                    text.innerHTML = "Team <a href=\"" + teamLink + "#patches\">is associated with</a> " + projectsCount + " patches. Deleting this team will remove it from all patches.";
                    ele.show(okInfo);
                }
                else
                {
                    ele.show(okInfo);
                }
                ele.show(patchdependencies);
            }

            if (opsCount === 0)
            {
                const deleteButton = ele.byId("deletebutton");
                if (deleteButton) ele.show(deleteButton);
            }
        });
    }

    delete()
    {
        const id = ele.byId("team-id").value;
        const name = ele.byId("team-name").value;
        if (confirm("Really delete " + name + " ?"))
        {
            const deleteButton = ele.byQuery("#deletebutton .button");
            const errorEle = ele.byQuery("#deletebutton .error");

            web.buttons.startSavingAnimButton(deleteButton);
            api.delete(
                "teams/" + id,
                {},
                (res) =>
                {
                    let msg = res.msg || JSON.stringify(res);
                    web.buttons.stopSavingAnimButton();
                    if (res.success)
                    {
                        document.location.href = "/myteams";
                    }
                    else
                    {
                        if (errorEle)
                        {
                            errorEle.innerText = "Failed to delete team: " + msg;
                            ele.show(errorEle);
                        }
                    }
                },
                (res) =>
                {
                    web.buttons.stopSavingAnimButton();
                    let msg = res.msg || JSON.stringify(res);
                    if (errorEle)
                    {
                        errorEle.innerText = "Failed to delete team: " + msg;
                        ele.show(errorEle);
                    }
                });
        }
    }

    updateTeam(button, isStaff)
    {
        web.buttons.startSavingAnimButton(button);
        const id = ele.byId("team-id").value;
        const name = ele.byId("team-name").value;
        const description = ele.byId("team-description").value;
        const visibility = ele.byId("team-visibility").value;

        const newSettings = {
            "name": name,
            "description": description,
            "visibility": visibility
        };

        const registerNamespaceEl = ele.byId("register-team-namespace");
        if (registerNamespaceEl && registerNamespaceEl.checked)
        {
            newSettings.registerNamespace = true;
        }

        if (isStaff)
        {
            const key = ele.byId("team-key").value;
            let extension = ele.byId("team-extension").value;
            const newExtension = ele.byId("new-team-extension").value;
            if (newExtension)
            {
                extension = extension + "," + newExtension.trim();
            }

            let namespace = ele.byId("team-namespace").value;
            const newNamespace = ele.byId("new-team-namespace").value;
            if (newNamespace)
            {
                namespace = namespace + "," + newNamespace.trim();
            }

            let todoNamespace = ele.byId("todo-namespace").value;
            const newTodoNamespace = ele.byId("new-todo-namespace").value;
            if (newTodoNamespace)
            {
                todoNamespace = todoNamespace + "," + newTodoNamespace.trim();
            }

            newSettings.key = key;
            newSettings.extensions = extension.split(",");
            newSettings.namespaces = namespace.split(",");
            newSettings.todoNamespaces = todoNamespace.split(",");
        }

        const errorEle = ele.byId("errors");
        if (errorEle) ele.hide(errorEle);
        api.patch(
            "teams/" + id, newSettings, (res) =>
            {
                web.buttons.stopSavingAnimButton(button);
                window.location.href = "/team/" + res.data._id + "/settings#profile";
                window.location.reload();
            }, (res) =>
            {
                web.buttons.stopSavingAnimButton(button, true, true);
                this.showError(res.data.errors);
            });
    }

    addNamespace(type, inputEle, button)
    {
        web.buttons.startSavingAnimButton(button);
        const namespace = inputEle.value;
        const apiUrl = "teams/" + this.teamId + "/namespace/" + namespace;
        const errorId = "add-" + type + "-error";
        api.post(apiUrl, { "type": type }, (res) =>
        {
            web.buttons.stopSavingAnimButton(button);
            window.location.href = "/team/" + res.data._id + "/settings#profile";
            window.location.reload();
        }, (res) =>
        {
            web.buttons.stopSavingAnimButton(button, true, true);
            this.showError(res.data.errors, errorId);
        });
    }

    showError(errors, eleId = "errors")
    {
        let msg = "";
        for (let i = 0; i < errors.length; i++)
        {
            msg += "<li>" + errors[i] + "</li>";
        }
        let html = "<ul>" + msg + "</ul>";

        const errorEle = ele.byId(eleId);
        if (errorEle)
        {
            errorEle.innerHTML = html;
            ele.show(errorEle);
        }
    }

    inviteTeamUser(button)
    {
        web.buttons.startSavingAnimButton(button);
        const name = ele.byId("team-inviteuser").dataset.autosuggestValue || ele.byId("team-inviteuser").value;
        const teamId = ele.byId("team-id").value;
        const fullAccess = ele.byId("inviteWritePermission").value;
        let readOnly = (fullAccess !== "true");

        api.post(
            "teaminvites/create",
            {
                "userName": name,
                "teamId": teamId,
                "readOnly": readOnly
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(false, false);
                const errorEle = ele.byId("invite-error");
                if (errorEle)
                {
                    errorEle.innerText = "Invitation not possible: \"" + res.msg + "\"";
                    ele.show(errorEle);
                }
            });
    }

    removeTeamMember(el)
    {
        const errorEle = ele.byId("invite-error");
        if (errorEle) ele.hide(errorEle);

        const userId = el.dataset.userid;
        const teamId = ele.byId("team-id").value;
        api.delete(
            "teams/" + teamId + "/members/" + userId,
            {},
            (res) =>
            {
                document.location.reload();
            },
            (res) =>
            {
                if (errorEle)
                {
                    errorEle.innerText = "Failed to remove team member: \"" + res.msg + "\"";
                    ele.show(errorEle);
                }
            });
    }

    setTeamPermissions(value, userId, cb = false)
    {
        let fullAccess = (value === "fullAccess");
        const teamId = ele.byId("team-id").value;
        api.put("teams/" + teamId + "/" + userId + "/permissions/write/" + fullAccess, {}, () =>
        {
            if (cb)
            {
                cb();
            }
            else
            {
                document.location.reload();
            }
        });
    }

    makeTeamOwner(el)
    {
        const errorEle = ele.byId("invite-error");
        if (errorEle) ele.hide(errorEle);

        const userId = el.dataset.userid;
        const teamId = ele.byId("team-id").value;
        api.post(
            "teams/" + teamId + "/owner",
            {
                "userId": userId
            },
            (res) =>
            {
                document.location.reload();
            },
            (res) =>
            {
                if (errorEle)
                {
                    errorEle.innerText = "Failed to change team ownership: \"" + res.msg + "\"";
                    ele.show(errorEle);
                }
            });
    }

    deleteTeam(el)
    {
        const errorEle = ele.byId("invite-error");
        if (errorEle) ele.hide(errorEle);

        let r = confirm("are you sure? delete team?");

        if (r)
        {
            const teamId = ele.byId("team-id").value;
            api.delete(
                "teams/" + teamId,
                {},
                (res) =>
                {
                    window.location.href = "/myteams";
                },
                (res) =>
                {
                    if (errorEle)
                    {
                        errorEle.innerText = "Failed to delete team: \"" + res.msg + "\"";
                        ele.show(errorEle);
                    }
                });
        }
    }

    revokeTeamInvitation(invitationId)
    {
        const errorEle = ele.byId("invite-error");
        if (errorEle) ele.hide(errorEle);

        api.delete("teaminvites/" + invitationId, {}, () =>
        {
            web.buttons.stopSavingAnimButton();
            document.location.reload();
        }, (res) =>
        {
            web.buttons.stopSavingAnimButton();
            if (errorEle)
            {
                errorEle.innerText = "Failed to revoke invitation: \"" + res.msg + "\"";
                ele.show(errorEle);
            }
        });
    }

    removeNamespace(namespace, type)
    {
        const data = { "type": type };
        api.delete("teams/" + this.teamId + "/namespace/" + namespace, data, (res) =>
        {
            if (res.success)
            {
                document.location.reload();
            }
            else
            {
                const errorEle = ele.byQuery("#add-namespace-error .warn-hint");
                if (errorEle) errorEle.innerText = res.msg;
            }
        });
    }
}
